export enum ECampaign {
    YAMAHA = 'YAMAHA',
    DEMO = 'DEMO',
}
